<template>
  <v-container fluid class="admin-discount-code">
    <v-row class="flex-grow-0">
      <v-col class="text-right">
        <v-btn color="primary"
               class="ml-2"
               @click="exportItems">
          {{ $t('export') }}
        </v-btn>
        <v-btn color="primary"
               class="ml-2"
               @click="create">
          {{ $t('admin_acc_discount_code.add_title') }}
        </v-btn>
      </v-col>
    </v-row>
    <AdminDiscountCodeList full-height
                            @filter="onFilterChange"
                            :refresh-trigger.sync="bookingRefreshTrigger"></AdminDiscountCodeList>
  </v-container>
</template>
<script>
import {ref} from "@vue/composition-api";
import AdminDiscountCodeList from "@/components/acc_booking/discount_code/AdminDiscountCodeList.vue";
import AddDiscountCodeModal from "@/components/acc_booking/discount_code/AddDiscountCodeModal.vue";

export default {
  name: 'DiscountCode',
  components: {AdminDiscountCodeList},
  setup(props, {root}) {
    const bookingRefreshTrigger = ref(false);
    const refresh = function () {
      bookingRefreshTrigger.value = !bookingRefreshTrigger.value;
    };

    const exportItems = function () {
      root.$downloadFile("aafb/admin/discount_code/export/", {
        filters: currentFilters.value,
      }, 'discount_codes.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    }

    const create = async function () {
      const needRefresh = await root.$dialog.showAndWait(AddDiscountCodeModal, {
        showClose: false,
        persistent: true,
        width: '60vw',
      });

      if (needRefresh) {
        refresh();
      }
    }

    const currentFilters = ref(null);
    const onFilterChange = function (filters) {
      currentFilters.value = filters;
    }

    return {
      bookingRefreshTrigger,
      refresh,

      exportItems,
      create,
      onFilterChange,
    }
  }
}
</script>

<style lang="less">
.admin-discount-code {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>

